<template>
  <div>
    <v-card
      :key="reRender"
      tile
      elevation="0"
      class="d-flex flex-column justify-center py-12"
      :min-height="settings.bg && settings.bg.height ? settings.bg.height : '700px'"
      :color="MIXIN_getBgInfo(settings, 'color')"
      :img="MIXIN_getBgInfo(settings, 'image')"
    >
      <v-container style="max-width: 1340px">
        <v-row 
          :class="['justify-center', {'px-12': $vuetify.breakpoint.mdAndUp}, {'px-4': !$vuetify.breakpoint.mdAndUp}]" 
          no-gutters
          :style="`${$vuetify.breakpoint.mdAndUp && settings['text-position'] === 'right' ? 'flex-direction: row-reverse !important' : ''}`"
        >
          <v-col 
            :class="
              [
                {'pr-8': $vuetify.breakpoint.mdAndUp && settings['text-position'] === 'left'}, 
                {'pl-8': $vuetify.breakpoint.mdAndUp && settings['text-position'] === 'right'}, 
                {'pb-5 text-center': !$vuetify.breakpoint.mdAndUp || settings['text-position'] === 'center'}
              ]
            " 
            :cols="!$vuetify.breakpoint.mdAndUp || settings['text-position'] === 'center' ? '12' : '6'"
          >
            <h1
              class="pb-4"
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
                font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
                `
              "
            >
              {{ settings.title.content }}
            </h1>

            <span
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important; 
                font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
                `
              "
              v-html="settings.subtitle.content"
            ></span>

            <div
              class="text-font"
              :style="
                `
                padding-top: 16px;
                `
              "
              v-html="formatedText"
            ></div>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
            <v-card 
              :color="settings['layer-color']" 
              :class="['rounded-xl px-12 py-8']" 
              elevation="0"
            >
              <v-form v-model="isFormValid" ref="form">
                <div v-for="(optId, optIndex) in settings.formOptions" :key="optIndex">
                  <span
                    class="item-title mb-4"
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                    {{getFormInfo(optId, 'label')}}*
                  </span> 

                  <v-text-field
                    v-if="optId !== 6"
                    v-mask="defineMask(optId, form[getFormInfo(optId, 'key')])"
                    :rules="defineRules(optId, form[getFormInfo(optId, 'key')])"
                    dense
                    outlined
                    color="grey"
                    background-color="white"
                    v-model="form[getFormInfo(optId, 'key')]"
                  />

                  <v-autocomplete
                    v-else-if="optId === 6"
                    :items="eventPlaces"
                    v-model="form[getFormInfo(optId, 'key')]"
                    :rules="defineRules(optId)"
                    :item-text="textFormated"
                    :item-value="valueFormated"
                    :menu-props="{ offsetY: true }"
                    :search-input.sync="location"
                    background-color="white"
                    outlined
                    autocomplete="off"
                    no-data-text="Digite para buscar"
                    dense
                  ></v-autocomplete>                               
                </div>

                <div v-if="settings.lists && settings.lists.length">
                  <span
                    class="d-block item-title mb-4"
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                    {{settings.listMsg}}
                  </span>
                  <v-checkbox
                    v-for="list in settings.selectedListsInfo"
                    v-model="selectedLists"
                    class="py-0 my-0 custom-checkbox"
                    :style="{
                      '--font-size-checkbox': `${MIXIN_getStyle(settings, 'text', 'font-size')}`,
                      '--font-color-checkbox': `${settings['text-color']}`,
                    }"
                    :key="list._codigo"
                    :label="list.nome"
                    :value="list.token"
                  />               
                </div>
              </v-form>

              <div class="text-center">
                <v-btn
                  :disabled="isBtnDisabled || loading"
                  elevation="0"
                  :style="{
                    backgroundColor: !isBtnDisabled ? `${MIXIN_getStyle(settings, 'button', 'background-color', 0)} !important` : 'lightgray !important',
                    borderRadius: `${MIXIN_getStyle(settings, 'button', 'border-radius', 0)} !important`
                  }"
                  @click="submitCrm"
                >
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="white"
                    size="16"
                    width="2"
                    class="mr-2"
                  />
                  <b 
                    :style="
                      `
                      color: ${MIXIN_getStyle(settings, 'button', 'color', 0)} !important;
                      `
                    "
                  >
                    Cadastrar
                  </b>
                </v-btn>            
              </div>              
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-snackbar
      :timeout="3000"
      v-model="dialogMessage"
      :color="dialogColor"
      center
      bottom
    >
      {{message}}
    </v-snackbar>  
  </div>
</template>

<script>
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection";
import { CRM_FORM_OPTIONS } from "../../schemas/sections"
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import Rules from "../../helpers/validations"

export default {
  mixins: [GetLayoutSectionMixin],
  directives: { mask },
  props: {
    settings: {type: Object},
  },

  computed: {
    ...mapGetters(["infos", "eventPlaces"]),
    alignCenter() {
      if (this.settings["text-position"] === "center") return true;
      else false;
    },

    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    },

    isBtnDisabled() {
      const haveLists = this.settings.lists && this.settings.lists.length
      if (haveLists) return !this.isFormValid || this.selectedLists.length === 0
      else return !this.isFormValid
    }
  },  

  data() {
    return {
      form: {},
      selectedLists: [],
      formTypes: CRM_FORM_OPTIONS(),
      location: '',
      isFormValid: false,
      dialogMessage: false,
      message: '',
      dialogColor: 'green',
      rules: Rules,
      loading: false,
      reRender: 0
    };
  }, 

  async mounted() {
    if (this.$route.params && this.$route.params.token) {
      await this.$store.dispatch("getCrmList", this.$route.params)
    }
  },

  watch: {
    async location(v) {
      if (v && v.length > 3) {
        await this.$store.dispatch("getGlobalPlaces", v);
      } else this.$store.commit("SET_ALL_EVENT_PLACES", []);
    },
  },  

  methods: {
    getFormInfo(id, key = 'key') {
      const result = this.formTypes.find(i => i.id === id)
      return result ? result[key] : id
    },

    textFormated(v) {
      let valueReplace = v.description.split(' - ')
      return `${valueReplace[0]}/${valueReplace[1]}`
    },    

    valueFormated(v) {
      let valueReplace = v.description.split(' - ')
      return `${valueReplace[0]}/${valueReplace[1]}/${valueReplace[2]}`
    },    

    defineMask(id, currentValue) {
      const tokens = {
        'X': { pattern: /[^]/ },
        '#': { pattern: /\d/ }
      }

      const mask = {mask: 'X'.repeat(100), tokens}

      if (id === 5) {
        mask.mask = currentValue && currentValue.length <= 14 ? "(##) ####-####" : "(##) #####-####"
      } else if (id === 4) {
        mask.mask = '##/##/####'
      }

      return mask
    },

    defineRules(id, currentValue) {
      let rules = []      
      if (id === 1) rules = [Rules.itsRequired, Rules.minCaractersCustomMsg(currentValue, 5, "Nome deve ter ao menos 5 caracteres")]
      else if (id === 2) rules = [Rules.checkEmail]
      else if (id === 3) rules = [Rules.itsRequired]
      else if (id === 4) rules = [Rules.validBirthdate]
      else if (id === 5) rules = [Rules.itsRequired, Rules.checkMaskedPhone]
      else if (id === 6) rules = [Rules.itsRequired]
  
      return rules
    },

    async submitCrm() {
      const [cidade, uf, pais] = this.form.city.split('/')

      const data = {
        tokens: this.selectedLists,
        email: this.form.email,
        nome_completo: this.form.name,
        telefone: this.form.phone.replace(/\D/g, ""),
        cpf: this.form.doc,
        cidade,
        uf, 
        pais,
        data_nascimento: this.form.birthdate
      }

      try {
        this.loading = true
        const registerCrm = await this.$store.dispatch("registerCrm", data)
        this.message = registerCrm.data.message
        this.dialogColor = 'green'
        this.dialogMessage = true
        this.clearForm();
      } catch (e) {
        console.log(e)
        if (e.response && e.response.data && e.response.data.message) this.message = e.response.data.message
        else this.message = "Erro de cadastro"

        this.dialogColor = 'red'
        this.dialogMessage = true
      } finally {
        this.loading = false
      }
    },

    clearForm() {
      this.form = {}
      this.selectedLists = []
      this.$refs.form.resetValidation()
      this.reRender++
    },

    closeDialog() {
      this.dialogMessage = false;
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0px;
}

span {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
}

.v-btn {
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.75px;
  text-align: center;
}

.item-title {
  font-size: 16px;
}

.text-font p {
  font-family: inherit !important;
}

.custom-checkbox /deep/ label {
  font-size: var(--font-size-checkbox) !important;
  color: var(--font-color-checkbox) !important;
}
</style>